import { render, staticRenderFns } from "./BaseData.vue?vue&type=template&id=b962051e&scoped=true"
import script from "./BaseData.vue?vue&type=script&lang=js"
export * from "./BaseData.vue?vue&type=script&lang=js"
import style0 from "./BaseData.vue?vue&type=style&index=0&id=b962051e&lang=less&scoped=true"
import style1 from "./BaseData.vue?vue&type=style&index=1&id=b962051e&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b962051e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b962051e')) {
      api.createRecord('b962051e', component.options)
    } else {
      api.reload('b962051e', component.options)
    }
    module.hot.accept("./BaseData.vue?vue&type=template&id=b962051e&scoped=true", function () {
      api.rerender('b962051e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/BaseData.vue"
export default component.exports